import React, { useContext, useEffect, useState, useMemo, useCallback } from "react";
import swal from 'sweetalert';
import { getAnimals, getAnimalsE } from "../../api/animalsApi";
import { getReproductions, getReproductionsByUser } from "../../api/reproductionApi";
import { getUsers } from "../../api/usersApi";
import { AuthContext } from "../../Contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import './Accueil.css';
import {FaHeartbeat, FaUsers , FaHeart, FaBed, FaPlus, FaCheckCircle, FaBell, FaChartLine, FaTachometerAlt, FaBaby} from 'react-icons/fa';
import { MdPregnantWoman } from 'react-icons/md';
import { GiCow, GiBabyBottle } from 'react-icons/gi';
import { getFermes, getFermesE } from "../../api/fermeApi";
import { FaEdit } from "react-icons/fa";
import { useSearchParams } from 'react-router-dom';

const AdminAccueil = () => {
  const { user } = useContext(AuthContext);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [animals, setAnimals] = useState([]);
  const [animalsE, setAnimalsE] = useState([]);
  const [reproductions, setReproductions] = useState([]);
  const [reproductionsE, setReproductionsE] = useState([]);
  const [users, setUsers] = useState([]);
  const [fermes, setFermes] = useState([]);
  const [hasAlerted, setHasAlerted] = useState(false);

  useEffect(() => {
    if (searchParams.get('welcome') === 'true') {
      swal({
        title: 'Bienvenue!',
        text: `Bienvenue ${user?.nom}! Votre compte et votre ferme "${user?.ferme?.nom}" ont été créés avec succès.`,
        icon: 'success',
        button: 'Commencer!',
      });
    }
  }, [searchParams]);

  useEffect(() => {
    if (user.role === 'admin') {
      getAnimals().then(data => setAnimals(data));
      getReproductions().then(data => setReproductions(data));
      getUsers().then(data => setUsers(data));
      console.log(fermes);
      console.log(users);
      console.log(user);
    } else {
      getAnimalsE().then(data => setAnimalsE(data));
      getReproductionsByUser(user.id).then(data => setReproductionsE(data.data));
      
    }
  }, [user.role, user.id]);

  const stats = useMemo(() => {
    const repros = user.role === 'admin' ? reproductions : reproductionsE;
    
    const calculated = {
      total: repros.length,
      gestation: 0,
      velage: 0,
      saillie: 0,
      repos: 0,
      croissance: 0,
      upcomingVelage: 0,
    };

    const today = new Date();
    
    repros.forEach(r => {
      // Compter les status
      const statusTitle = r.status?.titre;
      if (statusTitle === 'Gestation') calculated.gestation++;
      else if (statusTitle === 'Vêlage') calculated.velage++;
      else if (statusTitle === 'Saillie' || statusTitle === 'Oestrus') calculated.saillie++;
      else if (statusTitle === 'Repos') calculated.repos++;
      else if (statusTitle === 'croissance') calculated.croissance++;

      // Compter les vêlages à venir
      if (r.date_prevu_velage) {
        const dueDate = new Date(r.date_prevu_velage);
        const daysUntil = Math.ceil((dueDate - today) / (1000 * 60 * 60 * 24));
        if (daysUntil >= 0 && daysUntil <= 7) {
          calculated.upcomingVelage++;
        }
      }
    });

    return calculated;
  }, [reproductions, reproductionsE, user.role]);

  useEffect(() => {
    if (user.role !== 'admin' || hasAlerted || reproductions.length === 0) return;

    const alerts = [];
    const today = new Date();

    reproductions.forEach((r) => {
      if (!r.date_prevu_velage || !r.animal?.nom) return;

      const dueDate = new Date(r.date_prevu_velage);
      const daysUntil = Math.ceil((dueDate - today) / (1000 * 60 * 60 * 24));

      if (daysUntil === 0) {
        alerts.push(`${r.animal.nom} doit vêler AUJOURD'HUI!`);
      } else if (daysUntil > 0 && daysUntil <= 3) {
        alerts.push(`${r.animal.nom} va vêler dans ${daysUntil} jour(s).`);
      }
    });

    if (alerts.length > 0) {
      swal({
        title: 'Alertes Vêlage',
        text: alerts.join('\n\n'),
        icon: 'warning',
        button: 'Compris!',
      });
      setHasAlerted(true);
    }
  }, [reproductions, hasAlerted, user.role]);

  const quickActions = useMemo(() => 
    user.role === 'admin' ? [
      { title: 'Ajouter Animal', icon: <FaPlus />, path: '/admin/add-animal', color: '#667eea' },
      { title: 'Gérer Animaux', icon: <GiCow />, path: '/admin/animals', color: '#764ba2' },
      { title: 'Reproduction', icon: <FaHeartbeat />, path: '/admin/reproduction', color: '#f093fb' },
      { title: 'To-Do', icon: <FaCheckCircle />, path: '/admin/to-do', color: '#4facfe' },
    ] : [
      { title: 'Ajouter Animal', icon: <FaPlus />, path: '/eleveur/add-animal', color: '#667eea' },
      { title: 'Mes Animaux', icon: <GiCow />, path: '/eleveur/animals', color: '#764ba2' },
      { title: 'Reproduction', icon: <FaHeartbeat />, path: '/eleveur/reproduction', color: '#f093fb' },
      { title: 'To-Do', icon: <FaCheckCircle />, path: '/eleveur/to-do', color: '#4facfe' },
    ], 
  [user.role]);

  const statusCards = useMemo(() => [
    {
      title: 'Gestation',
      count: stats.gestation,
      icon: <MdPregnantWoman />,
      gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
    },
    {
      title: 'Vêlage',
      count: stats.velage,
      icon: <GiBabyBottle />,
      gradient: 'linear-gradient(135deg, #fc9191ff 0%, #f5576c 100%)'
    },
    {
      title: 'Saillie',
      count: stats.saillie,
      icon: <FaHeart />,
      gradient: 'linear-gradient(135deg, #e6e36aff 0%, #ddc910ff 100%)'
    },
    {
      title: 'Repos',
      count: stats.repos,
      icon: <FaBed />,
      gradient: 'linear-gradient(135deg, #70d476ff 0%, #1ef11eff 100%)'
    },
  ], [stats]);

  const handleNavigate = useCallback((path) => {
    navigate(path);
  }, [navigate]);

  return (
    <div className="accueil">
      <div className="accueil-header">
        <div className="welcome-section">
          <h1 className="welcome-title">
            <span className="user-name">Bonjour {user?.nom}</span>
          </h1>
          <p className="welcome-subtitle">
            {new Date().toLocaleDateString('fr-FR', {
              weekday: 'long',
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}
          </p>
          <p className="user-ferme">{user?.ferme?.nom} <a href="/admin/edit-ferm"><FaEdit /></a></p>
        </div>

        {stats.upcomingVelage > 0 && (
          <div className="alert-badge">
            <FaBell className="alert-icon-animate" />
            <span>{stats.upcomingVelage} vêlage(s) cette semaine</span>
          </div>
        )}
      </div>

      <div className="main-stats">
        <div className="stat-card-large">
          <div className="stat-icon">
            <GiCow />
          </div>
          <div className="stat-content">
            <h3>Total Animaux</h3>
            <p className="stat-number">{user.role === 'admin' ? animals.length : animalsE.length}</p>
          </div>
        </div>

        <div className="stat-card-large">
          <div className="stat-icon">
            <FaHeartbeat />
          </div>
          <div className="stat-content">
            <h3>Reproductions</h3>
            <p className="stat-number">{stats.total}</p>
          </div>
        </div>

        {user.role === 'admin' && (
          <div className="stat-card-large">
            <div className="stat-icon">
              <FaUsers />
            </div>
            <div className="stat-content">
              <h3>Utilisateurs</h3>
              <p className="stat-number">{users.length}</p>
            </div>
          </div>
        )}

        {stats.croissance >= 0 && (
          <div className="stat-card-large">
            <div className="stat-icon">
              <FaBaby />
            </div>
            <div className="stat-content">
              <h3>En Croissance</h3>
              <p className="stat-number">{stats.croissance}</p>
            </div>
          </div>
        )}
      </div>

      <div className="section">
        <h2 className="section-title">
          <FaChartLine className="section-icon" />
          Distribution par Status
        </h2>
        <div className="status-grid">
          {statusCards.map((card, index) => (
            <div
              key={index}
              className="status-card"
              style={{ background: card.gradient }}
            >
              <div className="status-icon">{card.icon}</div>
              <div className="status-info">
                <h3>{card.title}</h3>
                <p className="status-count">{card.count}</p>
                <div className="status-percentage">
                  {stats.total > 0 ? Math.round((card.count / stats.total) * 100) : 0}%
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="section">
        <h2 className="section-title">
          <FaTachometerAlt className="section-icon" />
          Actions Rapides
        </h2>
        <div className="quick-actions">
          {quickActions.map((action, index) => (
            <div
              key={index}
              className="action-card"
              onClick={() => handleNavigate(action.path)}
              style={{ '--card-color': action.color }}
            >
              <div className="action-icon">{action.icon}</div>
              <p className="action-title">{action.title}</p>
            </div>
          ))}
        </div>
      </div>

      
    </div>
  );
};

export default AdminAccueil;